import {Theme} from '@material-ui/core'
import {StyleRulesCallback} from '@material-ui/styles'

import primaryDesktopUrl from '../../../../../../assets/images/premierBanner/primary-desktop.png'
import primaryTabletUrl from '../../../../../../assets/images/premierBanner/primary-tablet.png'
import primaryMobileUrl from '../../../../../../assets/images/premierBanner/primary-mobile.jpg'

import secondaryDesktopUrl from '../../../../../../assets/images/premierBanner/secondary-desktop.png'
import secondaryTabletUrl from '../../../../../../assets/images/premierBanner/secondary-tablet.png'
import secondaryMobileUrl from '../../../../../../assets/images/premierBanner/secondary-mobile.jpg'

import bannerBackgroundUrl from '../../../../../../assets/images/premierBanner/background.svg'

export const styles: StyleRulesCallback<Theme, {}> = (theme) => ({
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '20px 30px 20px 400px',

    backgroundOrigin: 'border-box, border-box',
    backgroundRepeat: 'no-repeat, repeat-x',
    backgroundSize: 'contain, cover',

    [theme.breakpoints.down('md')]: {
      padding: '20px 30px 20px 250px',
    },

    [theme.breakpoints.down('xs')]: {
      padding: '40% 30px 20px',
    },
  },

  initialContainerBackground: {
    backgroundImage: `url(${primaryDesktopUrl}), url(${bannerBackgroundUrl})`,

    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${primaryTabletUrl}), url(${bannerBackgroundUrl})`,
    },

    [theme.breakpoints.down('xs')]: {
      backgroundImage: `url(${primaryMobileUrl}), url(${bannerBackgroundUrl})`,
    },
  },

  eligibleContainerBackground: {
    backgroundImage: `url(${secondaryDesktopUrl}), url(${bannerBackgroundUrl})`,

    [theme.breakpoints.down('md')]: {
      backgroundImage: `url(${secondaryTabletUrl}), url(${bannerBackgroundUrl})`,
    },

    [theme.breakpoints.down('xs')]: {
      backgroundImage: `url(${secondaryMobileUrl}), url(${bannerBackgroundUrl})`,
    },
  },
  bannerBody: {
    width: 'auto',
    display: 'flex',
    gap: '15px',
    flexGrow: 1,
    color: '#fff',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  bodyHead: {
    fontSize: '22px',
    fontWeight: 600,
    lineHeight: '28px',

    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      lineHeight: '24px',
    },
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'center',
    },
  },
  body: {
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '24px',

    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      lineHeight: '20px',
    },
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'center',
    },
  },
  eligibleBody: {
    padding: '10px 20px',
    borderRadius: '50px',
    border: '1px solid rgba(255, 255, 255, 0.50)',
    backgroundColor: 'rgba(255, 255, 255, 0.10)',
    width: 'fit-content',
  },
  eligibleBodyContent: {
    opacity: 1,
  },
  highlight: {
    color: '#8CBCFE',
  },
})
